export const FIELD_MAPPINGS = {
  period: 'periodName',
  legalentity: 'legalEntity',
  legalentitydescription: 'leDescription',
  enabledflag: 'enabledFlag',
  ustaxtype: 'usTaxType',
  localtaxtype: 'localTaxType',
  branch: 'branch',
  source: 'source',
  goldid: 'goldId',
  countrycode: 'countryCode',
  'minority%': 'minorityPercentage',
  parent1: 'parent1',
  ownership1: 'ownership1',
  parent2: 'parent2',
  ownership2: 'ownership2',
  parent3: 'parent3',
  ownership3: 'ownership3',
  parent4: 'parent4',
  ownership4: 'ownership4',
  parent5: 'parent5',
  ownership5: 'ownership5',
  parent6: 'parent6',
  ownership6: 'ownership6',
  parent7: 'parent7',
  ownership7: 'ownership7',
  parent8: 'parent8',
  ownership8: 'ownership8',
  parent9: 'parent9',
  ownership9: 'ownership9',
  parent10: 'parent10',
  ownership10: 'ownership10',
};

export const MIN_COLUMNS_NUMBER = 31;
export const MAX_COLUMNS_NUMBER = 31;
